// extracted by mini-css-extract-plugin
export default {"msg_container":"vha","message":"wha","show":"xha","fromRD":"yha","fromCustomer":"zha","note":"Aha","loading":"Bha","image":"Cha","initials":"Eha","input_wrapper":"Fha","input":"Gha"};
    if(module.hot) {
      // 1738836199272
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  